import React, { useEffect, useState } from 'react';
import { dropDowns } from '../../../Common/EquipmentJson';
import _ from 'lodash';

const EditableField = props => {
  const [fieldType, setFieldType] = useState();
  const [fieldValue, setFieldValue] = useState(props.value || '');

  useEffect(() => {
    var data = !_.isEmpty(props.data) ? props.data : Object.keys(dropDowns).includes(props.label);
    if (data) setFieldType('drop_down');
    else setFieldType('');
  }, [props.label]);

  useEffect(() => {
    setFieldValue(props.value);
  }, [props.value]);

  if (fieldType === 'drop_down') {
    const data = !_.isEmpty(props.data) ? props.data : dropDowns[props.label];
    return (
      <select className="edit-dropdown text-left" defaultValue={fieldValue} onChange={e => props.handleChange(e.target.value, props.label)}>
        {!_.isEmpty(data) &&
          data.map((value, index) => {
            return (
              <option key={index} value={value}>
                {`${value}`}
              </option>
            );
          })}
      </select>
    );
  } else {
    return (
      <input
        onChange={e => {
          props.handleChange(e.target.value, props.label);
          setFieldValue(e.target.value);
        }}
        value={fieldValue}
        className="w-100"
        style={{"border": "none", "borderBottom": "1px solid #075978"}}
      />
    );
  }
};

export default EditableField;
